const text = {
  errorMaxSizeAttachment: 'Ukuran file melebihi batas maksimum 5MB/gambar.',
};

export default text;
